import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45eddc55")

_pushScopeId("data-v-45eddc55")
const _hoisted_1 = /*#__PURE__*/_createVNode("h2", { class: "title" }, "Восстановление пароля", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "form-text" }, " Введите свой адрес электронной почты и мы отправим вам письмо с кодом для сброса пароля ", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Отправить код ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_email = _resolveComponent("icon-email")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("form", {
    class: "RestoreForm",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSendCode && _ctx.emitSendCode(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_s_input, {
      placeholder: "E-mail",
      value: _ctx.email,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event))
    }, {
      icon: _withId(() => [
        _createVNode(_component_icon_email, { class: "icon-email" })
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_s_button, {
      class: "green",
      loading: _ctx.loading
    }, {
      default: _withId(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode("span", {
      class: "back-text",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitBack && _ctx.emitBack(...args)))
    }, " Назад ")
  ], 32))
})